import { createReducer } from "@reduxjs/toolkit"

export const initialState = {
  isOpen: false,
  title: undefined,
  message: undefined,
  toConfirm: {}, // data model pending confirmation
  confirm: {} // data model has been confirmed, linked your component action on it
}

export default createReducer(initialState, {
  CONFIRM_DIALOG_OPEN: (state, action) => {
    // keep custom, model depends on each screen
    const { message, ...custom } = action.payload
    const overriddenMessage = message || state.message
    return {
      ...state,
      isOpen: true,
      message: overriddenMessage,
      ...custom
    }
  },

  // When confirm is set to YES,
  // Then close it, and move, "toConfirm" props into "confirm" props
  // Your component should be linked to "state.confirmDialog.confirm" props
  // You can pass custom arguments in action.payload
  CONFIRM_DIALOG_YES: (state, action) => ({
    ...state,
    data: action.payload ?? state.data,
    isOpen: false,
    toConfirm: undefined,
    confirm: state.toConfirm
  }),
  // Same for both, for the moment, it justs re init state
  CONFIRM_DIALOG_CLOSE: (state) => ({ ...state, isOpen: false }),
  CONFIRM_DIALOG_NO: (state) => ({ ...state, isOpen: false }),
  CONFIRM_DIALOG_RESET: () => initialState
})
